import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from './api/useApiFetch'
import { useAccess } from './access/useAccess'
import { ErrorScreen } from './screens/ErrorScreen'
import { MapScreen } from './screens/MapScreen'
import { NoAccessScreen } from './screens/NoAccessScreen'
import { SplashScreen } from './screens/SplashScreen'

export function AuthenticatedApp() {
  const { signOut } = useAuth()
  const call = useApiFetch()
  const { phase, retry } = useAccess(call)

  switch (phase) {
    case 'checking':
      return <SplashScreen />
    case 'denied':
      return <NoAccessScreen onSignOut={() => void signOut()} />
    case 'error':
      return <ErrorScreen onRetry={retry} />
    case 'allowed':
      return <MapScreen />
  }
}
